import { render } from "./press.vue?vue&type=template&id=20393b0c"
import script from "./press.vue?vue&type=script&lang=js"
export * from "./press.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/press.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20393b0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20393b0c', __exports__)) {
    api.reload('20393b0c', __exports__)
  }
  
  module.hot.accept("./press.vue?vue&type=template&id=20393b0c", () => {
    api.rerender('20393b0c', render)
  })

}


export default __exports__